import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import styles from './styles.module.scss';

interface Props {
  src: string;
  show: boolean;
  onClose: () => void;
}

const StyledIFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border-width: 0;
`;

const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.primary} !important;
  display: flex;
`;

const StyledModal = styled(Modal)`
  display: flex !important;
  justify-content: center;
  align-items: flex-start;

  .modal-dialog {
    width: 100%;
    height: 95%;
    margin-top: 10px;
  }

  .modal-content {
    border-width: 0px;
    height: 95%;
  }
`;

const WebView: React.FC<Props> = ({ src, show, onClose }) => {
  const { t } = useTranslation();

  return (
    <StyledModal className={styles.modal} show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title />
        <StyledButton onClick={onClose} variant="link" className="h3 p-0 mb-0 font-weight-bold">
          {t('common.close')}
        </StyledButton>
      </Modal.Header>
      <Modal.Body className="p-0">
        <StyledIFrame src={src} title="webView" />
      </Modal.Body>
    </StyledModal>
  );
};

export default WebView;
